const placeholderContent = (title) => ({
  title,
  intro:
    "eed a little help from our friends from time to time. Although we offer the one-stop convenience of annery integrated range of legal, financial services under one roof, there are occasions when our clients areaneed specia- list advice beyond the scope of our own expertise. That’s why we’ve developed close working relationships with a number of strategic partner.",
  description:
    "when an unknown printer took a galley of type and scrambled it to make a type specimen bookhas survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchan galley of type and scrambled it to make a type specimen book.",
  sectionTitle: "Raise capital faster & negotiate on your own terms",
  sectionText:
    "when an unknown printer took a galley offer typey anddey scrambled make a type specimen bookhas survived not only five centuries but also.",
  points: [
    "100% Better results",
    "Valuable Ideas",
    "Budget Friendly Theme",
    "Happy Customers",
  ],
  note: "when an unknown printer took a galley of type and scrambled it to make a type specimen bookhas a not only five centuries, but also the leap into electronic typesetting, remaining essentially unchan galley of type and scrambled it to make a type specimen book.",
  benefitTitle: "Company Key Benefits",
  benefitText:
    "when an unknown printer took a galley of type and scrambled it to make a type specimen bookhas a not only five centuries, but also the leap into electronic typesetting, remaining essentially unchan galley of type and scrambled it to make a type specimen book.",
  faqs: [
    {
      question: "Interdum et malesuada fames ac ante ipsum",
      answer:
        "when an unknown printer took a galley of type and scrambled it to make a type specimen bookhas a not only five centuries, but also the leap into electronic typesetting, remaining essentially unchan galley of type and scrambled it to make a type specimen book.",
      open: true,
    },
    {
      question: "Interdum et malesuada fames ac ante ipsum",
      answer:
        "when an unknown printer took a galley of type and scrambled it to make a type specimen bookhas a not only five centuries, but also the leap into electronic typesetting, remaining essentially unchan galley of type and scrambled it to make a type specimen book.",
    },
    {
      question: "Interdum et fames ac ante ipsum",
      answer:
        "when an unknown printer took a galley of type and scrambled it to make a type specimen bookhas a not only five centuries, but also the leap into electronic typesetting, remaining essentially unchan galley of type and scrambled it to make a type specimen book.",
    },
  ],
});

export const BOOKKEEPING_SERVICES = [
  {
    slug: "startup-bookkeeping",
    label: "Startup Bookkeeping",
    content: {
      title: "What does a startup need for bookkeeping?",
      intro:
        "A startup needs three things from day one: a separate business bank account, accounting software set up for its business model, and a routine for recording every transaction. Silverwave sets up all three for startups in Surrey, Delta, Langley and White Rock, then keeps your books current every month for a flat fee.",
      description:
        "Most founders are busy building a product or finding customers, so bookkeeping slips. Starting clean avoids an expensive catch-up at tax time and gives you organized records when a bank or grant program asks for them.",
      sectionTitle: "What's included in startup setup",
      sectionText: "A simple setup that grows with your business.",
      points: [
        "Chart of accounts built for your business",
        "Bank, card, Stripe, Square or Shopify connected",
        "Business and personal spending separated",
        "Receipt capture set up on your phone",
      ],
      note: "After setup, most startups begin on the Starter plan ($250/month) and move to Growth as transactions increase, with the same bookkeeper.",
      benefitTitle: "Common Questions",
      benefitText:
        "Straight answers to what business owners ask us about startup bookkeeping.",
      faqs: [
        { question: "When should a startup get a bookkeeper?",
          answer:
            "As soon as money starts moving through the business. Setting up correctly at the start costs less than untangling a year of mixed personal and business transactions at tax time.",
        },
        {
          question: "I paid for business costs with my personal card. What now?",
          answer:
            "Keep the receipts. We record those purchases properly as money you put into the business, so nothing is lost. Going forward, use a business card for business spending.",
        },
        { question: "We just registered the business. Can you help?",
          answer:
            "Yes. We set up your books once your business bank account is open. We don't give incorporation or tax advice, but we can refer you to a local professional.",
        },
        {
          question: "Do you prepare SR&ED or grant applications?",
          answer:
            "No. We keep your expense records organized so your SR&ED or grant advisor can prepare the claim faster.",
        },
      ],
      cta: "Book a Free Health Check",
    },
  },
  {
    slug: "monthly-bookkeeping",
    label: "Monthly Bookkeeping",
    content: {
      title: "What is monthly bookkeeping?",
      intro:
        "Monthly bookkeeping means your transactions are recorded, your bank and credit card accounts are reconciled, and your books are closed every month. With Silverwave, that's done by the 15th of the following month for one flat fee.",
      description:
        "We work in QuickBooks Online or Xero for businesses in Surrey, Delta, Langley and White Rock. You send receipts and bills through a shared folder or app; we handle the rest.",
      sectionTitle: "What's included every month",
      sectionText:
        "Everything you need to keep your records current and ready for year-end.",
      points: [
        "Bank and credit card reconciliation",
        "Sales and expense categorization",
        "GST and PST recorded on each transaction",
        "Monthly profit & loss report",
      ],
      note: "At year-end we give your tax preparer a clean, reconciled set of books, which usually means fewer questions and a faster turnaround.",
      benefitTitle: "Common Questions",
      benefitText:
        "Straight answers to what business owners ask us about monthly bookkeeping.",
      faqs: [
        {
          question: "How much does monthly bookkeeping cost?",
          answer:
            "Silverwave's plans start at $250 a month for up to 50 transactions. Your exact fee is set after a free 20-minute health check and only changes if your volume does.",
        },
        { question: "What do I need to send you each month?",
          answer:
            "Read-only bank and credit card access, receipts and bills, and your sales records. We give you a simple checklist and a secure folder",
         },
        { question: "Do you file my GST or taxes?",
          answer:
          "No. We keep your books accurate and give your tax preparer everything they need. We can refer you to a local tax professional",
      },
      ],
      cta: "Book a Free Health Check",
    },
  },
  {
    slug: "catch-up-bookkeeping",
    label: "Catch-Up Bookkeeping",
    content: placeholderContent("Catch-Up Bookkeeping"),
  },
  {
    slug: "quickbooks-xero-setup",
    label: "QuickBooks & Xero Setup",
    content: placeholderContent("QuickBooks & Xero Setup"),
  },
  {
    slug: "trucking-bookkeeping",
    label: "Trucking Bookkeeping",
    content: placeholderContent("Trucking Bookkeeping"),
  },
  {
    slug: "construction-bookkeeping",
    label: "Construction Bookkeeping",
    content: placeholderContent("Construction Bookkeeping"),
  },
];

export const getServicePath = (slug) => `/services/${slug}`;

export const getServiceBySlug = (slug) =>
  BOOKKEEPING_SERVICES.find((service) => service.slug === slug);

export const getServiceHref = (label) => {
  const service = BOOKKEEPING_SERVICES.find((item) => item.label === label);
  return service ? getServicePath(service.slug) : "/services-details";
};
